export const NAME = 'proofs';

export const RESULT_INSUFFICIENT_REASON_LABEL = {
  NONE: '',
  SCANNED_DOCUMENTS:
    'Documents appear to be scanned or photos. Please upload the original PDF downloaded directly from the issuing website.',
  PRINT_TO_PDF:
    'Documents appear to be created using "Print to PDF." Please upload the original system-generated PDF from the issuing website.',
  INVALID_DOCUMENT_TYPE:
    'Unsupported document type. Please upload a paystub, bank statement, tax document, or official benefits statement downloaded as an original PDF.',
  MERGED_DOCUMENT:
    'Multiple statement or pay periods were combined into one file. Please upload each period as a separate original PDF.',
  FOREIGN_ISSUED_DOCUMENT:
    'Some foreign-issued documents cannot be verified. Please provide an alternative supported income document.',
  CROPPED_DOCUMENT:
    'Document appears incomplete or cropped. Please upload the full, unaltered original PDF including all pages.',
  PENDING_EMPLOYER_VERIFICATION: 'Pending Employer Verification',
  // ITL-2808: retired from selection (removed from ProofResultInsufficientReasonEnum
  // + OLV_REASON_KEYS), but kept here for READ display so legacy proofs still
  // carrying this code render readable copy instead of the raw enum. Mirrors the
  // backend Ecto.Enum + SalesforceCaseCreator.@reason_code_labels read retention.
  CANNOT_VERIFY_BUSINESS_LEGITIMACY: 'Cannot Verify Business Legitimacy',
  CANNOT_FIND_BUSINESS_CONTACT_INFO: 'Cannot Find Business Contact Info',
  MISSING_SALARY_HOURLY_RATE: 'Missing Salary/Hourly Rate',
  MISSING_START_DATE: 'Missing Start Date',
  MISSING_TITLE: 'Missing Title',
  MISSING_EMPLOYEE_NAME: 'Missing Employee Name',
  NAME_DOES_NOT_MATCH: 'Name Does Not Match',
  EDITED_DOCUMENT_IN_SUBMISSION: 'Edited Document Found in Submission',
  MISSING_COMPANY_NAME: 'Missing Company Name',
  MISSING_LETTERHEAD: 'Missing professional letterhead',
  MISSING_WEBSITE: 'Missing Company website',
  DATE_EXCEEDS_REASONABLE_WINDOW: 'Date Exceeds Reasonable Window',
  UNVERIFIED_INCOME: 'Unverified Income',
  NO_RESPONSE_NO_INCOME: 'Unverified No Income',
  NO_CONTACTS_AVAILABLE: 'No Contacts Available',
  NO_VERIFIED_CONTACTS: 'No Verified Contacts',
  UNVERIFIED_OFFER_LETTER: 'Unverified',
  CUSTOM: ''
};
